import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  formField: {
    marginBottom: theme.spacing(2),
  },
}))

export { useStyles }
